import React, { useCallback, useEffect } from 'react';
import { useTranslate } from '@im/react-localization';
import { useNavigate } from 'react-router-dom';
import { Toast } from '@im/ui-lib/zenith/Toast';
import { ToastIntent } from '@im/ui-lib/zenith/common';

export type AddToQuoteToastProps = {
  description: React.ReactNode;
  onHideToast: () => void;
  quoteEditorURL: string;
  show: boolean;
  toastIntent?: ToastIntent;
};

export default function AddToQuoteToast(props: Readonly<AddToQuoteToastProps>) {
  const {
    description,
    onHideToast,
    quoteEditorURL,
    show,
    toastIntent = 'success',
  } = props;

  const translate = useTranslate();
  const navigate = useNavigate();

  const handleGoToQuote = useCallback(() => {
    navigate(quoteEditorURL);
  }, [navigate, quoteEditorURL]);

  const body =
    toastIntent === 'success'
      ? description
      : translate('ProductConfig.SomethingWentwrongError');
  const icon = toastIntent === 'success' ? 'QuotePlus' : 'AlertCircle';
  const header =
    toastIntent === 'success' ? 'ProductConfig.Addedtoquote' : 'Common.Error';

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onHideToast();
      }, 3000);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return (
    <Toast
      actionButtonText={translate('ProductConfig.Gotoquote')}
      header={translate(header)}
      icon={icon}
      intent={toastIntent}
      onActionButtonClick={handleGoToQuote}
      onCloseButtonClick={onHideToast}
      open={show}
      position="top-right"
      supportingText={body}
      sx={{
        button: {
          alignSelf: 'center',
        },
      }}
    />
  );
}
